import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SpartaxFolgeAuftragDto, SpartaxFolgeAuftragKundeDto } from 'src/app/data/dto/spartax/spartax-auftrag.dto';
import { environment } from 'src/environments/environment';

type SpartaxFollowUpDialogStep = 'years' | 'customers' | 'confirm';

@Component({
  selector: 'app-spartax-follow-up-dialog',
  templateUrl: './spartax-follow-up-dialog.component.html',
  styleUrls: ['./spartax-follow-up-dialog.component.scss'],
})
export class SpartaxFollowUpDialogComponent implements OnInit {
  @Input()
  followUpData: SpartaxFolgeAuftragDto;

  public lastYearOfNewOrder: number;
  public selectedStep: SpartaxFollowUpDialogStep;
  public excludedCustomerFormModelIds: string[] = [];
  public readonly availableSteps: SpartaxFollowUpDialogStep[] = environment.spartaxProd ?
    ['customers', 'confirm'] :
    ['years', 'customers', 'confirm'];

  constructor(private modalController: ModalController) { }

  ngOnInit() {
    this.lastYearOfNewOrder = this.followUpData?.LastYearOfNewOrder ?? new Date().getFullYear() - 1;
    this.selectedStep = this.availableSteps[0];
  }

  closeModal() {
    this.modalController.dismiss();
  }

  onSelectedStepChange(value: SpartaxFollowUpDialogStep) {
    if (this.availableSteps.includes(value)) {
      this.selectedStep = value;
    }
  }

  onLastYearChange(value: string | number) {
    const parsedValue = Number(value);
    if (!Number.isNaN(parsedValue)) {
      this.lastYearOfNewOrder = parsedValue;
    }
  }

  canGoBack() {
    return this.currentStepIndex > 0;
  }

  canGoForward() {
    return this.currentStepIndex < this.availableSteps.length - 1;
  }

  isConfirmStep() {
    return this.selectedStep === 'confirm';
  }

  goToPreviousStep() {
    if (this.canGoBack()) {
      this.selectedStep = this.availableSteps[this.currentStepIndex - 1];
    }
  }

  goToNextStep() {
    if (this.canGoForward()) {
      this.selectedStep = this.availableSteps[this.currentStepIndex + 1];
    }
  }

  isCustomerIncluded(customer: SpartaxFolgeAuftragKundeDto) {
    return !this.excludedCustomerFormModelIds.includes(customer.FormModelId);
  }

  onCustomerInclusionChange(formModelId: string, checked: boolean) {
    if (checked) {
      this.excludedCustomerFormModelIds = this.excludedCustomerFormModelIds.filter(x => x !== formModelId);
    } else if (!this.excludedCustomerFormModelIds.includes(formModelId)) {
      this.excludedCustomerFormModelIds = [...this.excludedCustomerFormModelIds, formModelId];
    }
  }

  startFollowUp() {
    if (this.includedCustomers.length === 0) {
      return;
    }

    const updatedFollowUpData: SpartaxFolgeAuftragDto = {
      ...this.followUpData,
      ListItemId: null,
      LastYearOfNewOrder: this.lastYearOfNewOrder,
      Kunden: this.includedCustomers.map(x => ({ ...x }))
    };

    this.modalController.dismiss({ followUpData: updatedFollowUpData }, 'start-follow-up');
  }

  trackByFormModelId(index: number, customer: SpartaxFolgeAuftragKundeDto) {
    return customer.FormModelId;
  }

  get includedCustomers(): SpartaxFolgeAuftragKundeDto[] {
    return (this.followUpData?.Kunden || []).filter(x => !this.excludedCustomerFormModelIds.includes(x.FormModelId));
  }

  get currentStepIndex() {
    return this.availableSteps.indexOf(this.selectedStep);
  }
}
